module.exports = __webpack_public_path__ + "img/subAra.2a80875f.gif";